import React, { useEffect, useRef } from "react";
import { SWRConfig } from "swr";
import { createSWRDevtools } from "./createSWRDevTools";
export var SWRDevToolsContext = React.createContext({
    events: null,
});
if (typeof window !== "undefined") {
    // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = React;
}
export var SWRDevTools = function (_a) {
    var children = _a.children;
    var _b = useRef(createSWRDevtools()).current, swrdevtools = _b[0], events = _b[1];
    useEffect(function () {
        window.postMessage({ type: "panelshow" });
    }, []);
    return (React.createElement(SWRDevToolsContext.Provider, { value: { events: events } },
        React.createElement(SWRConfig, { value: { use: [swrdevtools] } }, children)));
};
//# sourceMappingURL=SWRDevTools.js.map